import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInbox = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.49 20H6.48999C5.55999 20 4.66999 19.63 4.01999 18.97C3.35999 18.31 3 17.42 3 16.49V9.83002C3.02 9.29002 3.17001 8.75998 3.42001 8.28998L5.26999 5.21997C5.50999 4.86997 5.82001 4.56999 6.20001 4.35999C6.57001 4.14999 6.98 4.03 7.41 4H16.57C16.99 4.02 17.42 4.13999 17.79 4.35999C18.16 4.56999 18.48 4.86997 18.72 5.21997L20.57 8.28998C20.84 8.75998 20.99 9.29002 21 9.83002V16.49C21 17.42 20.63 18.31 19.97 18.97C19.31 19.63 18.43 20 17.5 20H17.49Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3 10L7.07001 10.81C7.34001 10.88 7.59001 11.02 7.79001 11.22C7.99001 11.41 8.14 11.65 8.22 11.92L8.51999 13.11C8.68999 13.63 9.01 14.09 9.44 14.42C9.87 14.75 10.4 14.94 10.94 14.96H13.03C13.57 14.94 14.1 14.76 14.53 14.42C14.97 14.09 15.29 13.63 15.45 13.11L15.75 11.92C15.83 11.65 15.99 11.41 16.19 11.22C16.39 11.03 16.64 10.89 16.91 10.82L20.98 10.01",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	})]
});
export default SvgInbox;
